module.exports = __webpack_public_path__ + "media/assets/img/faces/shanezheng-4971cd9095e841d1a1d3f619f9727313.jpg";